<template>
  <div class="home flex-column">
    <div class="title-container flex-row">
      <div class="flex-column">
        <span class="title">{{ $t('assets') }}</span>
        <ul class="subtitle flex-row">
          <li @click="goToPrograms">{{ $t('programs') }}&nbsp;&gt;&nbsp;</li>
          <li @click="goToDealersList">{{ domain }}&nbsp;&gt;&nbsp;</li>
          <li>{{ $t('assets') }}</li>
        </ul>
      </div>
    </div>
    <div class="content flex-column">
      <DataTable :headings="assetsTH" :rows="assets">
        <template v-slot:originalFileNameSlot="slotProps">
          <a :href="slotProps.row.url">{{ slotProps.row.originalFileName }}</a>
        </template>
        <template v-slot:replaceSlot="slotProps">
          <Upload :asset="slotProps.row" @sendurl="refreshPage" />
        </template>
      </DataTable>
    </div>
  </div>
</template>

<script>
import Upload from '@/components/Upload.vue';
import DataTable from '@/components/DataTable.vue';
import { mapState } from 'vuex';
import assetsTH from '@/utils/tableHeaders/assetsTH';

export default {
  name: 'CCAssets',
  components: { Upload, DataTable },
  data() {
    return {
      assets: [],
      assetsTH: assetsTH(),
    };
  },
  methods: {
    getAssets() {
      const loader = this.$loading.show();
      const { domain } = this;
      this.$store
        .dispatch('getAssets', {
          domain,
        })
        .then((res) => {
          this.assets = res;
        })
        .catch((error) => {
          if (error.data) {
            this.$notify({
              group: 'primary',
              type: 'error',
              text: error.data.error,
            });
          }
        })
        .finally(() => {
          loader.hide();
        });
    },
    refreshPage(res) {
      if (res) {
        this.getAssets();
      }
    },
    goToPrograms() {
      this.$store.state.global.programName = null;
      this.$store.state.global.programImage = null;
      this.$router.push({
        name: 'Programs',
      });
      this.$store.state.activeNavTab = this.activeNavBar[0];
    },
    goToDealersList() {
      this.$router.push({
        name: 'Dealer-List',
      });
      this.$store.state.activeNavTab = this.activeNavBar[1];
    },
  },
  computed: {
    ...mapState({
      domain: (state) => state.global.programName,
    }),
  },
  created() {
    if (this.domain) {
      this.getAssets();
    } else {
      this.$router.push({
        name: 'Programs',
      });
    }
  },
};
</script>

<style lang="scss" scoped>
.home {
  width: 100%;
  .title {
    font-size: 32px;
    font-weight: 100;
    text-transform: uppercase;
  }
  .subtitle {
    font-size: 14px;
    margin-top: 5px;
    list-style-type: none;
    margin-bottom: 0px;
    padding-left: 0px;
    li {
      cursor: pointer;
    }
    li:last-child {
      cursor: default;
      font-weight: bold;
    }
  }
}
.content {
  height: 100%;
  flex-wrap: wrap;
}
.title-container {
  text-align: left;
  border-bottom: 1px #dfe4e8 solid;
  padding-left: 40px;
  padding-bottom: 25px;
  padding: 30px 50px 30px 30px;
  justify-content: space-between;
  .right {
    display: flex;
  }
}
</style>
